var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"javascript:void(0)"}},[_c('canvas',{staticStyle:{"border":"1px solid #DEE2E6"},attrs:{"id":_vm._uid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }